import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/MarketsMagazine.css';

const MarketsMagazine = () => {
  return (
    <>
      <Helmet>
        <title>Markets Magazine - In-Depth Market Analysis & Insights | Redbox Global</title>
        <meta name="description" content="Markets Magazine delivers comprehensive market analysis, trading strategies, investment insights, and portfolio management advice. Expert commentary on stocks, bonds, commodities, and currencies." />
        <meta name="keywords" content="markets magazine, investment magazine, trading insights, market analysis, portfolio management, investment strategies, financial markets, stock analysis" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/markets-magazine" />
        <meta property="og:title" content="Markets Magazine - In-Depth Market Analysis & Insights | Redbox Global" />
        <meta property="og:description" content="Comprehensive market analysis, trading strategies, and investment insights for serious investors." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/markets-magazine" />
        <meta name="twitter:title" content="Markets Magazine - In-Depth Market Analysis & Insights | Redbox Global" />
        <meta name="twitter:description" content="Comprehensive market analysis, trading strategies, and investment insights for serious investors." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/markets-magazine" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Markets Magazine</h1>
          <p className="page-subtitle">Premium insights for sophisticated investors and market professionals</p>
        </div>
        
        <div className="page-content">
          <a href="/article/equity-market-outlook-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=600&fit=crop" alt="Markets magazine" />
              </div>
              <div className="featured-content">
                
                <h2>The 2026 Equity Market Outlook: Navigating Volatility</h2>
                <p>As markets face unprecedented uncertainty from geopolitical tensions to monetary policy shifts, our comprehensive analysis reveals the sectors poised for outperformance. Leading strategists from Goldman Sachs, Morgan Stanley, and BlackRock share exclusive insights on portfolio positioning, risk management, and the opportunities emerging from market dislocations.</p>
                <span className="article-meta">Featured Report • 25 min read • Premium</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/fixed-income-renaissance" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop" alt="Fixed income" />
                </div>
                <div className="article-content">
                 
                  <h2>The Bond Market Renaissance</h2>
                  <p>Why top investors are returning to fixed income after a decade in the wilderness.</p>
                  <span className="article-meta">20 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/commodities-supercycle" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1605792657660-596af9009e82?w=600&h=400&fit=crop" alt="Commodities" />
                </div>
                <div className="article-content">
                 
                  <h2>The Coming Commodities Supercycle</h2>
                  <p>Infrastructure spending and supply constraints create once-in-a-generation opportunities.</p>
                  <span className="article-meta">18 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/currency-wars-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=600&h=400&fit=crop" alt="Currency markets" />
                </div>
                <div className="article-content">
                  
                  <h2>Currency Wars: The Dollar's Dominance at Risk</h2>
                  <p>How shifting central bank policies are reshaping global currency markets.</p>
                  <span className="article-meta">22 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketsMagazine;
